// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3420":"8a07f0fe","6756":"7fd9a35a","9303":"8a07f0fe"}[chunkId] + ".chunk.css";
};